import { combineReducers } from 'redux'
import licenses from './license-reducers'
import users from './user-reducers'
import keycloak from './keycloak-reducers'
import notes from './note-reducers'
import products from './product-reducers'
import identityProviders from './idp-reducers'
import groups from './group-reducers'
import customers from './customer-reducers'
import subsidiaries from './subsidiary-reducers'
import currentUser from './currentUser-reducers'
import memberships from './membership-reducers'
import revisions from './revision-reducers'
import settings from './setting-reducers'
import orders from './order-reducers'
import dashboard from './dashboard-reducers'

const rootReducer = combineReducers({
  licenses,
  users,
  keycloak,
  notes,
  products,
  identityProviders,
  groups,
  customers,
  subsidiaries,
  currentUser,
  memberships,
  revisions,
  settings,
  orders,
  dashboard,
})

export default rootReducer
